import {
  BaSeButton,
  BaSeDataTable,
  BaSeIcon,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import React, { Fragment } from 'react';
import { useInterviewController } from '../../../../../../../hooks/controllers/interview-controller';
import { cpfMask } from '../../../../../../../utils/formatters/cpfMask';
import { ButtonContainer, Container } from './send-multiple-certificate-style';

function SendMultipleCertificate({ interviews, closeModal }) {
  const [data, setData] = React.useState(interviews);

  const { postSendInterviewCertificate } = useInterviewController();

  const remove = React.useCallback(
    (value) => {
      const response = data?.filter((item) => {
        return item !== value;
      });
      setData(response);
    },
    [data, setData],
  );
  const hasMutiple = () => {
    if (data?.length > 1) {
      return {
        accessorKey: 'lixeira',
        header: 'Remover',
        mapper: ({ values }) => (
          <BaSeIcon
            name="trash-alt"
            size="16"
            onClick={() => remove(values)}
            description="icon-lightulb-als"
            color={BaSeTheme.colors.institucionais.cinzaSebrae30}
          />
        ),
      };
    }
    return {
      accessorKey: 'lixeira',
      header: '',
      mapper: ({ values }) => <></>,
    };
  };
  const configTable = [
    {
      accessorKey: 'name',
      header: 'Nome completo',
      mapper: ({ values }) => {
        return (
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            {values.candidate.name}
          </BaSeSmall1>
        );
      },
    },
    {
      accessorKey: 'cpf',
      header: 'CPF',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          {cpfMask(values.candidate.cpf)}
        </BaSeSmall1>
      ),
    },
    hasMutiple(),
  ];

  return (
    <Fragment>
      <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
        Lista de candidato(s) selecionado(s) para o envio de certificado(s)
      </BaSeParagraph>
      <Container withAutoScroll>
        <BaSeDataTable
          config={configTable}
          hasHeader={false}
          items={data}
          shadow="0"
        />
      </Container>
      <ButtonContainer>
        <BaSeButton
          value="Enviar certificado"
          onClick={() => {
            const idList = interviews.map((interview) => interview.id);
            postSendInterviewCertificate({
              sendAll: false,
              idsInterviews: idList,
            }).finally(() => closeModal());
          }}
          color={BaSeTheme.colors.defaultColors.black}
          width="150px"
        />
        <BaSeButton
          value="Cancelar"
          type="secondary"
          color={BaSeTheme.colors.defaultColors.black}
          onClick={() => closeModal()}
          width="150px"
        />
      </ButtonContainer>
    </Fragment>
  );
}

export default SendMultipleCertificate;
